module.exports = __webpack_public_path__ + "img/warnings-04.f4ec5ede.png";